<template>
  <div class="current-conversation-wrapper">
    <div class="current-conversation" @scroll="onScroll" v-if="showCurrentConversation">
      <div class="header">
        <div class="name">{{ name }}</div>
        <div class="name"></div>
        <!-- <div class="btn-more-info"
          :class="showConversationProfile ? '' : 'left-arrow'"
          @click="showMore"
          v-show="!currentConversation.conversationID.includes('SYSTEM')"
          title="查看详细信息">
        </div> -->
      </div>
      <div class="content">
        <div class="message-list" ref="message-list" @scroll="this.onScroll">
          <div class="more" v-if="!isCompleted">
            <el-button
              type="text"
              @click="$store.dispatch('getMessageList', currentConversation.conversationID)"
            >查看更多</el-button>
          </div>
          <div class="no-more" v-else>没有更多了</div>
          <message-item v-for="(message,index) in currentMessageList" :key="message.ID+index" :message="message"/>
        </div>
        <div v-show="isShowScrollButtomTips" class="newMessageTips" @click="scrollMessageListToButtom">回到最新位置</div>
      </div>
      <div class="footer" v-if="showMessageSendBox" >
        <message-send-box @sendLyMsg="sendLyMsg" @sendBlackMsg="sendBlackMsg"/>
      </div>
    </div>
    <div class="profile" v-if="showConversationProfile" >
      <conversation-profile/>
    </div>
    <!-- 群成员资料组件 -->
    <member-profile-card />
    <el-dialog
      :visible="ymVisible"
      custom-class="noTitledialog"
      :show-close="true"
      width="577px">
      <div style="width:600px;background:#f82b18;padding-bottom:15px">
        <el-row>
          <el-col style="text-align:center;margin-top:25px">
            <div style="width:90%;position:absolute;text-align:right">
              <span style="color:white;cursor:pointer" @click="ymVisible = false">X</span>
            </div>
            <div>
              <img src="@/assets/pcImage/logoWhite.png" style="width:202px;height:52px;"/>  
            </div>
          </el-col>
          <el-col class="whitebackgroud">
            <el-col class="hiredMessage">录用通知</el-col>
            <!-- <el-col :offset="1" :span="8" class="nameFont">尊敬的张美肥：</el-col> -->
            <el-col :offset="1" :span="22" class="descFont">
              <el-form :rules="rules" ref="lyForm" :model="form">
                <el-form-item prop="lyMsg">
                  <el-input type="textarea" v-model="form.lyMsg" placeholder="请输入通知内容" style="width:100%" :rows="8"></el-input>
                </el-form-item>  
              </el-form>
            </el-col>
          </el-col>
        </el-row>
        <div class="flex-space-betw" style="width:95%;padding:0px 20px">
          <div>
            <div class="homeFont">润邦彩虹家园</div>
            <span class="homeFont">{{new Date().Format('yyyy-MM-dd')}}</span>
          </div>
          <el-button class="btn" @click="saveLyMsg">保存并发送</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      title="拉黑"
      :visible.sync="blackVisible"
      width="30%">
      <el-form :rules="rules" ref="tsForm" :model="tsForm">
        <el-form-item prop="tsMsg">
          <el-input type="textarea" v-model="tsForm.tsMsg" placeholder="请输入拉黑原因" style="width:100%" :rows="8"></el-input>
          <el-checkbox v-model="checked" style="color:red;margin-top:15px">投诉，注意该残疾人被投诉3次后将被进行封号处理！</el-checkbox>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="blackVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveTouSuMsg">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="发送面试邀请函"
      :visible.sync="msVisible"
      width="30%">
      <el-form :rules="rules" ref="msForm" :model="msForm">
        <el-form-item prop="msDate">
          <el-date-picker
            v-model="msForm.msDate"
            style="border:1px solid #f2f2f2;width:100%;"
            type="datetime"
            prefix-icon="el-icon"
            placeholder="选择面试时间"
            :picker-options="pickerOptions0"
            default-time="10:00:00">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="msVisible = false">取 消</el-button>
        <el-button type="primary" @click="msHandler">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import MessageSendBox from '../message/message-company-send-box'
import MessageItem from '../message/message-item'
import ConversationProfile from './conversation-profile.vue'
import MemberProfileCard from '../group/member-profile-card'
import Vue from 'vue'
import { getAction , postAction , putAction} from '@/comm/manage';

export default {
  name: 'CurrentConversation',
  components: {
    MessageSendBox,
    MessageItem,
    ConversationProfile,
    MemberProfileCard
  },
  data() {
    return {
      pickerOptions0: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        },
      },
      isShowScrollButtomTips: false,
      preScrollHeight: 0,
      showConversationProfile: false,
      timeout: '',
      curItem:{},
      ymVisible:false,
      blackVisible:false,
      checked:false,
      form:{
        lyMsg:""
      },
      tsForm:{
        tsMsg:""
      },
      msForm:{
        msDate:""
      },
      rules:{
          lyMsg: [{ required: true, message: "请输入通知内容", trigger: "blur" }],
          tsMsg: [{ required: true, message: "请输入拉黑原因", trigger: "blur" }],
          msDate: [{ required: true, message: "请输入面试时间", trigger: "blur" }]
      },
      msVisible:false
    }
  },
  computed: {
    ...mapState({
      currentConversation: state => state.conversation.currentConversation,
      currentUnreadCount: state => state.conversation.currentConversation.unreadCount,
      currentMessageList: state => state.conversation.currentMessageList,
      isCompleted: state => state.conversation.isCompleted
    }),
    ...mapGetters(['toAccount', 'hidden']),
    // 是否显示当前会话组件
    showCurrentConversation() {
      return !!this.currentConversation.conversationID
    },
    name() {
      if (this.currentConversation.type === 'C2C') {
        return this.currentConversation.userProfile.nick || this.toAccount
      } else if (this.currentConversation.type === 'GROUP') {
        return this.currentConversation.groupProfile.name || this.toAccount
      } else if (this.currentConversation.conversationID === '@TIM#SYSTEM') {
        return '系统通知'
      }
      return this.toAccount
    },
    showMessageSendBox() {
      return this.currentConversation.type !== this.TIM.TYPES.CONV_SYSTEM
    }
  },
  mounted() {
    this.$bus.$on('image-loaded', this.onImageLoaded)
    this.$bus.$on('scroll-bottom', this.scrollMessageListToButtom)
    if (this.currentConversation.conversationID === '@TIM#SYSTEM') {
      return false
    }
    if(this.currentConversation.conversationID != "")
      this.getJobInfo();
  },
  updated() {
    this.keepMessageListOnButtom()
    // 1. 系统会话隐藏右侧资料组件
    // 2. 没有当前会话时，隐藏右侧资料组件。
    //    背景：退出群组/删除会话时，会出现一处空白区域
    if (this.currentConversation.conversationID === '@TIM#SYSTEM' || 
        typeof this.currentConversation.conversationID === 'undefined') {
      this.showConversationProfile = false
    }
  },
  watch: {
    currentUnreadCount(next) {
      if (!this.hidden && next > 0) {
        this.tim.setMessageRead({ conversationID: this.currentConversation.conversationID })
      }
    },
    hidden(next) {
      if (!next && this.currentUnreadCount > 0) {
        this.tim.setMessageRead({ conversationID: this.currentConversation.conversationID })
      }
    },
    currentConversation(){
      this.getJobInfo();
    }
  },
  methods: {
    getJobInfo(){
      if(this.currentConversation.conversationID){

        let userInfo = Vue.ls.get("Login_Userinfo");
        let params = {ucId: userInfo.ucId ,udId:this.currentConversation.conversationID.replace('C2C','')};
        getAction('/tsdisabledpositionref/tsDisabledPositionRef/list',params).then(res =>{
          if(res.success){
            if(res.result.records.length > 0){
              this.curItem = res.result.records[0];
              getAction('/position/tsCompanyPosition/jobList',{cpId:res.result.records[0].cpId,curPage:0,pageSize:100}).then(r =>{
                if(r.success){
                  if(r.result && r.result.length > 0){
                    this.curItem = r.result[0];
                  }
                }else{
                  console.log('获取职位信息错误')
                }
              })
            }
          }else{

          }
        })
      }
    },
    sendLyMsg(){
      this.ymVisible = true;
    },
    sendBlackMsg(){
      this.blackVisible = true;
    },
    msHandler(){
      this.$refs.msForm.validate((valid) => {
        if (valid) {
          this.updateStatus(2);
        }
      });
    },
    noHandler(){
      this.updateStatus(3);
    },
    saveLyMsg(){
      this.$refs.lyForm.validate((valid) => {
        if (valid) {
          let params = {udId: this.currentConversation.conversationID.replace('C2C',''),ucId: Vue.ls.get("Login_Userinfo").ucId};
          getAction("/tsdisabledpositionref/tsDisabledPositionRef/list",params).then(result =>{
            if(result.success){
              if(result.result.records.length > 0){
                if(result.result.records[0].status == 3 || result.result.records[0].status == 4 || result.result.records[0].status == 5){
                  this.$message.error('不能发送录用通知')
                  return
                }
                params.id = result.result.records[0].id;
                params.lyMsg = this.form.lyMsg;
                params.status = 4;
                putAction("/tsdisabledpositionref/tsDisabledPositionRef/edit", params).then((res) => {
                    if (res.success) {
                      this.$message.success('已发送录用通知');
                      this.form = {};
                      this.ymVisible = false;
                    } else {
                      // this.$message.error('面试邀请发送失败')
                    }
                  }
                );
              }
            }
          })
        }
      })
    },
    saveTouSuMsg(){
      this.$refs.tsForm.validate((valid) => {
        if (valid) {
          let params = {udId: this.currentConversation.conversationID.replace('C2C',''),ucId: Vue.ls.get("Login_Userinfo").ucId};
          getAction("/tsdisabledpositionref/tsDisabledPositionRef/list",params).then(result =>{
            if(result.success){
              if(result.result.records.length > 0){
                params.id = result.result.records[0].id;
                if(this.checked){
                  if(result.result.records[0].complaintTotal == null){
                    params.complaintTotal = 1;
                  }else{
                    params.complaintTotal = parseInt(result.result.records[0].complaintTotal) + 1;
                  }
                }
                params.complaint = this.tsForm.tsMsg;
                params.status = 5;
                putAction("/tsdisabledpositionref/tsDisabledPositionRef/edit", params).then((res) => {
                    if (res.success) {
                      // this.$message.success('感谢您的投诉与建议，我们会尽快处理！');
                      this.$alert('感谢您的投诉与建议，我们会尽快处理！', '投诉成功', {
                        confirmButtonText: '确定',
                        callback: action => {
                          this.blackVisible = false;
                          this.checked = false;
                          this.tsForm = {};
                        }
                      });
                    } else {
                      // this.$message.error('面试邀请发送失败')
                    }
                  }
                );
              }
            }
          })
        }
      })
    },
    updateStatus(status){
      //待优化，减少网络IO
      let params = {udId: this.currentConversation.conversationID.replace('C2C',''),ucId: Vue.ls.get("Login_Userinfo").ucId};
      getAction("/tsdisabledpositionref/tsDisabledPositionRef/list",params).then(result =>{
        if(result.success){
          if(result.result.records.length > 0){
            
            params.id = result.result.records[0].id;
            params.status = status;
            if(status == 2){
              if(result.result.records[0].status == 3 || result.result.records[0].status == 4 || result.result.records[0].status == 5){
                this.$message.error('不能发送面试邀请')
                return
              }
              params.msDate = new Date(this.msForm.msDate).Format('yyyy-MM-dd  hh:mm:ss');
            }
            putAction("/tsdisabledpositionref/tsDisabledPositionRef/edit", params).then((res) => {
                if (res.success) {
                  if(status == 2){
                    // this.$message.success('已发送面试邀请');
                    getAction("/position/tsCompanyPosition/jobList",{cpId:result.result.records[0].cpId,curPage:0,pageSize:10}).then(rr =>{
                      if(rr.success){
                        this.form = {data:'yms',description:rr.result[0].cpPositionName+" "+rr.result[0].cpMinSalary+"-"+rr.result[0].cpMaxSalary+" "+rr.result[0].cpProvinceLabel+","+rr.result[0].cpWorkAddress,extension:rr.result[0].cpHrPhone+","+params.msDate}
                        this.sendCustomMessage();
                      }
                    });
                    this.msVisible = false;
                  }
                  else{
                    this.$message.success('已列为不合适')
                  }
                } else {
                  // this.$message.error('面试邀请发送失败')
                }
              }
            );
          }
        }
      })
    },
    sendCustomMessage() {
      if (
        this.form.data.length === 0 &&
        this.form.description.length === 0 &&
        this.form.extension.length === 0
      ) {
        this.$store.commit('showMessage', {
          message: '不能发送空消息',
          type: 'info'
        })
        return
      }
      const message = this.tim.createCustomMessage({
        to: this.toAccount,
        conversationType: "C2C",
        payload: {
          data: this.form.data,
          description: this.form.description,
          extension: this.form.extension
        }
      })
      this.$store.commit('pushCurrentMessageList', message)
      this.tim.sendMessage(message).catch(error => {
        this.$store.commit('showMessage', {
          type: 'error',
          message: error.message
        })
      })
      Object.assign(this.form, {
        data: '',
        description: '',
        extension: ''
      })
      this.sendCustomDialogVisible = false
    },
    onScroll({ target: { scrollTop } }) {
      let messageListNode = this.$refs['message-list']
      if (!messageListNode) {
        return
      }
      if (this.preScrollHeight - messageListNode.clientHeight - scrollTop < 20) {
        this.isShowScrollButtomTips = false
      }
    },
    // 如果滚到底部就保持在底部，否则提示是否要滚到底部
    keepMessageListOnButtom() {
      let messageListNode = this.$refs['message-list']
      if (!messageListNode) {
        return
      }
      // 距离底部20px内强制滚到底部,否则提示有新消息
      if (this.preScrollHeight - messageListNode.clientHeight - messageListNode.scrollTop < 20) {
        this.$nextTick(() => {
          messageListNode.scrollTop = messageListNode.scrollHeight
        })
        this.isShowScrollButtomTips = false
      } else {
        this.isShowScrollButtomTips = true
      }
      this.preScrollHeight = messageListNode.scrollHeight
    },
    // 直接滚到底部
    scrollMessageListToButtom() {
      this.$nextTick(() => {
        let messageListNode = this.$refs['message-list']
        if (!messageListNode) {
          return
        }
        messageListNode.scrollTop = messageListNode.scrollHeight
        this.preScrollHeight = messageListNode.scrollHeight
        this.isShowScrollButtomTips = false
      })
    },
    showMore() {
      this.showConversationProfile = !this.showConversationProfile
    },
    onImageLoaded() {
      this.keepMessageListOnButtom()
    }
  }
}
</script>

<style lang="stylus" scoped>
.topDiv {
  font-family: PingFangSC-Regular, PingFang SC;
  color: rgba(51, 51, 51, 1);
  .flex-space-betw{
    display flex;
    justify-content space-between;
    align-items center;
  }
  .hiredMessage {
    text-align center;
    font-size: 30px;
    font-weight: 600;
    padding-top: 18px;
  }

  .nameFont {
    font-size: 18px;
    font-weight: 600;
    padding-top: 18px;
    text-align: left;
  }

  .homeFont {
    font-size: 18px;
    font-weight: 600;
    color: rgba(255, 255, 255, 1);
    line-height: 25px;
    text-align: left;
    // margin: 20px 0 0 15px;
  }

  .descFont {
    font-size: 16px;
    font-weight: 600;
    padding-top: 18px;
    line-height: 30px;
    text-align: left;
  }
  .btn{
    font-family: PingFangSC-Regular, PingFang SC;
    border none;
    margin-right 20px;
  }

  .whitebackgroud {
    width: 89%;
    height: 350px;
    background: rgba(255, 255, 255, 1);
    border-radius: 2px;
    margin 50px 40px 20px 20px;
    // margin: 20px 0 0 15px;
  }

  .marginTop {
    margin-top: 20px;
  }

  .content {
    min-width: 600px;
    height: 100%;
  }
}

/* 当前会话的骨架屏 */
.current-conversation-wrapper
  height 80vh
  background-color white
  color #1c2438
  display flex
  .resp
    position absolute;
    bottom 0;
    width:100%;
    height:40px;
    background:#F2F2F2;
    display flex;
    justify-content right;
    align-items center;
    padding-left 75%;
    .btn
      width: 67px;
      height: 23px;
      border-radius: 11px;
      opacity: 0.6;
      line-height 0px;
      padding 0px;
      color #aaaaaa;
    .btnYm
      color #f82b18;
      border: 1px solid #f82b18;
    .btnNo
      border: 1px solid #aaaaaa;
  .current-conversation
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 80vh;
  .profile
    height: 80vh;
    overflow-y: scroll;
    border-left 1px solid #e7e7e7
    flex-shrink 0
  .more
    display: flex;
    justify-content: center;
    font-size: 12px;
  .no-more
    display: flex;
    justify-content: center;
    color: #a5b5c1;
    font-size: 12px;
    padding: 50px 10px;

.header
  text-align left
  border-bottom 1px solid #e7e7e7
  height 50px
  position relative
  .name
    // height 50px
    padding 0 20px
    color #1c2438
    font-size 18px
    font-weight bold
    line-height 50px
    background:rgba(247,247,247,1); 
    span 
      margin 0 5px 0 5px
      font-size:14px
      font-weight:400
      color #aaaaaa 
  .jobDetail
    // height:10px;
    width 100%;
    position: absolute;
    background:rgba(247,247,247,1);
    line-height 40px;
    padding-left 20px;
    color #aaaaaa
    font-size 14px
    z-index 2000;
    span 
      padding-right 10px;
  .btn-more-info
    position absolute
    top 10px
    right -15px
    border-radius 50%
    width 30px
    height 30px
    cursor pointer
    &::before
      position absolute
      right 0
      z-index 0
      content ""
      width: 15px
      height: 30px
      border: 1px solid #e7e7e7
      border-radius: 0 100% 100% 0/50%
      border-left: none
      background-color #f5f5f5
    &::after
      content ""
      width: 8px;
      height: 8px;
      transition: transform 0.8s;
      border-top: 2px solid #a5b5c1;
      border-right: 2px solid #a5b5c1;
      float:right;
      position:relative;
      top: 11px;
      right: 8px;
      transform:rotate(45deg)
    &.left-arrow
      transform rotate(180deg)
      &::before
        background-color white
    &:hover
      &::after
        border-color #5cadff
.content
  display: flex;
  flex 1
  flex-direction: column;
  height: 100%;
  overflow: hidden;
  position: relative;
  .message-list
    width: 100%;
    box-sizing: border-box;
    overflow-y: scroll;
    padding: 0 20px;
  .newMessageTips
    position: absolute
    cursor: pointer;
    padding: 5px;
    width: 120px;
    margin: auto;
    left: 0;
    right: 0;
    bottom: 5px;
    font-size: 12px;
    text-align: center;
    border-radius: 10px;
    border: $border-light 1px solid;
    background-color: white;
    color: #2d8cf0;
.footer
  border-top: 1px solid #e7e7e7;
.show-more {
  text-align: right;
  padding: 10px 20px 0 0;
}
</style>
